<template>
  <div class="notfound flex">
    <img src="../assets/404.png" alt="">
    <div class="desc">
      <div class="num">404</div>
      <div>抱歉，你访问的页面地址有误，<br />或者该页面不存在</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created() {},
  methods: {

  },
};
</script>

<style scoped lang="less">
.notfound{
  justify-content: center;
  height: 100vh;
  img{
    width: 246.577px;
  }
  .desc{
    margin-left: 96px;
    text-align: left;
  }
  .num{
    font-size: 64px;
  }
}
</style>
